"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
require("../../css/modules/general/ModalContainer.css");
require("../../css/modules/onboarding/AccountModal.css");
const config_1 = require("../../assets/styles/config");
const loginCopy_1 = require("../../copy/loginCopy");
const SearchBar_1 = __importDefault(require("../Dashboard/SearchBar"));
const StyledMargin_1 = require("../Dashboard/StyledMargin");
const StyledMessageContainer_1 = require("../Dashboard/StyledMessageContainer");
const StyledGraphic_1 = require("../Dashboard/StyledGraphic");
const StyledHeader_1 = require("../Dashboard/StyledHeader");
const noSearch_webp_1 = __importDefault(require("../../assets/images/dashboard/noSearch.webp"));
const MalomoButton_1 = require("../Dashboard/MalomoButton");
const Avatar = styled_components_1.default.div `
  background: ${config_1.colors.pavement};
`;
const AvatarLetter = styled_components_1.default.div `
  font: Bold ${config_1.fontSizes.extraLarge} ${config_1.fontFamilies.primary};
  color: ${config_1.colors.thundercloud};
`;
const ModalHeader = styled_components_1.default.h2 `
  font: Bold ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
`;
const AccountTitle = styled_components_1.default.h3 `
  font: Bold ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  margin-bottom: 5px;
`;
const SmallFont = styled_components_1.default.div `
  font: ${config_1.fontSizes.small} ${config_1.fontFamilies.primary};
`;
class AccountModal extends react_1.Component {
    constructor() {
        super(...arguments);
        this.renderAccounts = (accounts) => {
            if (accounts.length === 0) {
                return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, { height: '220px' },
                    react_1.default.createElement(StyledGraphic_1.StyledGraphic, { alt: 'document emerging from a filing cabinet', src: noSearch_webp_1.default }),
                    react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, "No Accounts")));
            }
            const accountMap = accounts.map((account) => {
                const props = this.props;
                function handleSelectAccount() {
                    props.onSelectAccount(account);
                }
                return (react_1.default.createElement("li", { className: 'list-group-item', key: account.node.name + account.node.id },
                    react_1.default.createElement("div", { className: 'row align-items-center' },
                        react_1.default.createElement("div", { className: 'col-auto' },
                            react_1.default.createElement(Avatar, { className: 'multi-account avatar' },
                                react_1.default.createElement(AvatarLetter, { className: 'multi-account-letter' }, account.node.name.charAt(0)))),
                        react_1.default.createElement("div", { className: 'col ml-n2' },
                            react_1.default.createElement(AccountTitle, { className: 'mb-1 name' }, account.node.name),
                            react_1.default.createElement(SmallFont, { className: 'small mb-0' }, account.node.primaryHostedDomain.token),
                            this.props.userIsAdmin && (react_1.default.createElement(SmallFont, { className: 'small mb-0' }, atob(account.node.id)))),
                        react_1.default.createElement("div", { className: 'col-auto' },
                            react_1.default.createElement(SmallFont, { className: 'btn btn-sm btn-white', id: account.node.name.replace(/\s/g, ''), onClick: handleSelectAccount }, "Go")))));
            });
            return (react_1.default.createElement("ul", { className: 'list-group list-group-flush list my-n3' }, accountMap));
        };
    }
    render() {
        return (react_1.default.createElement("div", { className: 'modal-card card', id: 'account-modal' },
            react_1.default.createElement("div", { className: 'card-header' },
                react_1.default.createElement(ModalHeader, { className: 'card-header-title', id: 'exampleModalCenterTitle' }, loginCopy_1.loginCopy.modalHeader),
                react_1.default.createElement("button", { "aria-label": 'Close', className: 'close', "data-dismiss": 'modal', onClick: this.props.onToggleModal, type: 'button' },
                    react_1.default.createElement("span", { "aria-hidden": 'true' }, "\u00D7"))),
            react_1.default.createElement("div", { className: 'card-body' },
                this.props.userIsAdmin && (react_1.default.createElement("div", { className: 'mt-n4' },
                    react_1.default.createElement(SearchBar_1.default, { onSearch: this.props.handleSearch }))),
                this.renderAccounts(this.props.accounts),
                react_1.default.createElement(StyledMargin_1.StyledMargin, { top: '20px' }, this.props.hasMore ? (react_1.default.createElement(MalomoButton_1.MalomoButton, { onClick: this.props.handleLoadNext }, "Load More")) : null))));
    }
}
exports.default = AccountModal;
